const pageDescription = title =>
  `A free, interactive map of ${title}. Compare different specialties for Couples Match. Locate medical internships, residencies, and fellowships in the US and US Territories.`;

export default pageDescription;
